/**
 * This is the utilities
 * @type {Object}
 */
module.exports = {
    /**
     * Detect which app opens this web site
     * @return {Object} The app information which opens this web site
     */
    detectAppInfo: function() {
        const userAgent = window.navigator.userAgent;
        let ret = userAgent.match(/mosoteach-ios\/(\d+)/);
        if (ret != null) {
            return {
                app: 'TEACH',
                platform: 'IOS',
                buildNumber: +(ret[1])
            }
        }

        return {
            app: 'TEACH',
            platform: 'WEB',
            buildNumber: 100
        }
    }
};